import { AtoNDefinition } from '@ais-ui/api-spec/config';
import React, { useState } from 'react';
import {
  getAtonStyle,
  getVirtualAtonStyle,
  latLonToShape,
  shapeToVectorLayer,
  useLayers,
} from '@ais-ui/react-openlayers';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiEye, PiEyeSlash } from 'react-icons/pi';
import { noop } from 'lodash';

interface EnabledShowAtonButtonProps {
  aton: AtoNDefinition;
}

export const EnabledShowAtonButton = ({ aton }: EnabledShowAtonButtonProps) => {
  const [isApplied, setIsApplied] = useState<boolean>(false);

  const { addLayer, doesLayerExist, zoomToLayer, removeLayerById } =
    useLayers();

  const onApply = () => {
    if (doesLayerExist(aton.uuid as string)) {
      removeLayerById(aton.uuid as string);
      setIsApplied(false);
      return;
    }

    if (!aton?.position?.coordinates) {
      return;
    }

    const longitude = aton.position.coordinates[0];
    const latitude = aton.position.coordinates[1];

    const shape = latLonToShape(latitude, longitude);

    const layer = shapeToVectorLayer(shape);

    if (aton.virtual === 0) {
      layer.setStyle(getAtonStyle());
    } else {
      layer.setStyle(getVirtualAtonStyle());
    }

    addLayer(
      layer,
      aton.name as string,
      true,
      true,
      false,
      shape.properties,
      aton.uuid as string
    );
    zoomToLayer(layer);
    setIsApplied(true);
  };

  return (
    <ShowAtonButton disabled={false} isApplied={isApplied} onApply={onApply} />
  );
};

interface ShowAtonButtonProps {
  onApply: () => void;
  isApplied: boolean;
  disabled: boolean;
}

export const DisabledShowAtonButton = () => {
  return <ShowAtonButton disabled={true} isApplied={false} onApply={noop} />;
};

export const ShowAtonButton = ({
  onApply,
  isApplied,
  disabled,
}: ShowAtonButtonProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size="smIcon"
          variant="ghost"
          onClick={onApply}
          disabled={disabled}
        >
          {isApplied ? (
            <PiEyeSlash className="h-4 w-4" />
          ) : (
            <PiEye className="h-4 w-4"></PiEye>
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{isApplied ? 'Hide AtoN' : 'Show AtoN'}</TooltipContent>
    </Tooltip>
  );
};
